import { useMemo } from 'react'
import { getRelevantQuarterlyPeriod, usePlans, useProfile } from '@front/model'

type RelevantQuarterlyPlanState = {
  hasRelevantQuarterlyPlan: boolean
  isLoading: boolean
}

export function useHasRelevantQuarterlyPlan(): RelevantQuarterlyPlanState {
  const { user } = useProfile()
  const { data: plans, isLoading } = usePlans(user?.userId)

  const hasRelevantQuarterlyPlan = useMemo((): boolean => {
    const relevantPeriod = getRelevantQuarterlyPeriod()
    return plans?.some((plan) => plan.period === relevantPeriod) ?? false
  }, [plans])

  return { hasRelevantQuarterlyPlan, isLoading }
}
